import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import ServiceMenu from "../../components/services/ServiceMenu";
import { CategoryAPI } from "../../api";

const Service = () => {
	const { category, item } = useParams();
	const [serviceItem, setServiceItem] = useState(null);
	const [meta, setMeta] = useState({
		title: "",
		description: "",
		keywords: "",
	});
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		setIsLoading(true);
		CategoryAPI.getServiceItem(item)
			.then((res) => {
				setServiceItem(res.data);
				setMeta({
					title: res.data.meta_title || res.data.title,
					description: res.data.meta_description || res.data.short_description,
					keywords: res.data.meta_keywords || res.data.title,
				});
				setIsLoading(false);
			})
			.catch((err) => {
				console.error(err);
				setIsLoading(false);
			});
	}, [category, item]);

	return (
		<>
			<title>{meta.title}</title>
			<meta name="description" content={meta.description} />
			<meta name="keywords" content={meta.keywords} />

			<main className="bg-gray-50 min-h-screen pt-20 pb-20">
				<div className="max-w-7xl mx-auto px-4">
					<div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
						{/* Left Side: Content */}
						<div className="lg:col-span-8">
							{isLoading ? (
								<div className="animate-pulse space-y-8">
									<div className="h-96 bg-gray-200 rounded-2xl w-full"></div>
									<div className="h-10 bg-gray-200 rounded w-1/2"></div>
									<div className="h-4 bg-gray-200 rounded w-full"></div>
								</div>
							) : (
								<article className="space-y-8">
									{/* Breadcrumb */}
									<nav className="flex items-center space-x-2 text-xs font-bold uppercase tracking-widest text-brand-600">
										<Link to="/services" className="ha:underline">
											Services
										</Link>
										<span className="text-gray-300">/</span>
										<span>{serviceItem?.category?.title}</span>
									</nav>

									{/* Main Image */}
									<div className="relative rounded-2xl overflow-hidden shadow-2xl border border-white">
										<img
											src={serviceItem?.image}
											alt={serviceItem?.title}
											className="w-full h-100px object-cover"
										/>
										<div className="absolute inset-0 bg-linear-to-t from-black/40 to-transparent" />
									</div>

									{/* Content Text */}
									<div className="bg-white rounded-2xl p-8 md:p-12 shadow-sm border border-gray-100">
										<h1 className="Ethnocentric text-2xl md:text-4xl text-gray-900 mb-6 uppercase leading-tight">
											{serviceItem?.title}
										</h1>
										<div className="prose prose-blue max-w-none text-gray-600 leading-relaxed space-y-4">
											{serviceItem?.description?.split("\n").map((para, i) => (
												<p key={i}>{para}</p>
											))}
										</div>
									</div>
								</article>
							)}
						</div>

						{/* Right Side: Sidebar Menu */}
						<aside className="lg:col-span-4 lg:sticky lg:top-32 h-fit">
							<div className="bg-white rounded-2xl p-6 shadow-xl border border-gray-100">
								<h4 className="Ethnocentric text-md mb-6 text-brand-600 tracking-widest border-b pb-4">
									Related Services
								</h4>
								<ServiceMenu />
							</div>
						</aside>
					</div>
				</div>
			</main>
		</>
	);
};

export default Service;
